export default {
  shapes: (state) => state.shapes,
  shapesByKeywords: (state) => state.shapesByKeywords,

  find: (state) => state.find,
  read: (state) => state.read,
};
